import React, { useEffect, useState } from "react";

import ArticlePreview from "./ArticlePreview";
import {
  MarginContainer,
  HBox,
  ShowMoreCarousel,
  CenterContainer,
  Loader,
} from "@liro_u/react-components";

import { getTrad } from "@liro_u/cms-front";

import { useAuthContext } from "@liro_u/react-auth-components";
import { useLanguageContext } from "@liro_u/cms-front";

const ArticleCarousel = ({
  nbSlide = 3,
  nbArticlePerSlide = 2,
  ...content
}) => {
  const [articles, setArticles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuthContext();
  const { language } = useLanguageContext();

  useEffect(() => {
    const getXArticles = async (nb) => {
      setIsLoading(true);

      const filters = {
        nb,
        sortFilter: { createdAt: -1 },
      };

      const headers = {
        "Content-Type": "application/json",
      };
      if (user) {
        headers.Authorization = `Baerer ${user.token}`;
      }

      const response = await fetch(
        process.env.REACT_APP_PROXY + "/api/article/nb/",
        {
          method: "POST",
          body: JSON.stringify(filters),
          headers,
        }
      );

      const json = await response.json();

      if (response.ok) {
        setArticles(json);
      } else {
      }
      setIsLoading(false);
    };
    getXArticles(nbSlide * nbArticlePerSlide);
  }, [nbArticlePerSlide, nbSlide, user]);

  const generateSlide = (startArticle) => {
    let slideChildren = [];

    let currentArticle = startArticle;

    while (
      articles.length > currentArticle &&
      currentArticle - startArticle < nbArticlePerSlide &&
      currentArticle < articles.length
    ) {
      slideChildren.push(
        <MarginContainer
          margin={"10px"}
          marginBottom={"0px"}
          marginTop={"0px"}
          style={{
            width:
              "calc(100% / " +
              Math.min(articles.length - startArticle, nbArticlePerSlide) +
              ")",
            height: " 100%",
          }}
        >
          <ArticlePreview
            image={articles[currentArticle].image}
            description={getTrad(
              articles[currentArticle],
              "description",
              language
            )}
            name={getTrad(articles[currentArticle], "name", language)}
            _id={articles[currentArticle]._id}
            style={{
              width: "100%",
              height: "100%",
            }}
          />
        </MarginContainer>
      );
      currentArticle++;
    }
    return (
      <HBox
        key={startArticle}
        style={{ width: "100%", height: "100%", overflow: "hidden" }}
      >
        {slideChildren}
      </HBox>
    );
  };
  const generateSlides = () => {
    const slides = [];

    let currentStartingArticle = 0;
    while (
      currentStartingArticle <= (nbSlide - 1) * nbArticlePerSlide &&
      currentStartingArticle < articles.length
    ) {
      slides.push(generateSlide(currentStartingArticle));
      currentStartingArticle += nbArticlePerSlide;
    }

    return slides;
  };

  return (
    <ShowMoreCarousel {...content}>
      {isLoading
        ? [
            <CenterContainer>
              <Loader delay={-1} />
            </CenterContainer>,
          ]
        : generateSlides()}
    </ShowMoreCarousel>
  );
};

export default ArticleCarousel;
